/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module NavigationModule
 */

import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';

import { INavState } from '../../navigation.types';
import './subheader-nav.component.less';

export interface ISubheaderNavState extends INavState {
    label: string;
}

/**
 * @description Subheader navigation component generally used for detail states.
 * @author alextsg
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'subheader-nav',
    templateUrl: './subheader-nav.component.html',
})
export class SubheaderNavComponent {
    @Input()
    public states: ISubheaderNavState[] = [];

    /**
     * Track by function for ngFor iterator on states.
     */
    public trackByState(index: number, state: ISubheaderNavState): string {
        return state.name;
    }
}
